import { useEffect, useState } from "react";
import { Minus, Play, Plus, Square } from "lucide-react";
import { audioCtx } from "../lib/synth";

export const Metronome = () => {
  const [bpm, setBpm] = useState(90);
  const [beats, setBeats] = useState(4);
  const [on, setOn] = useState(false);
  const [beat, setBeat] = useState(-1);

  useEffect(() => {
    if (!on) return;
    const c = audioCtx();
    let next = c.currentTime + 0.05;
    let n = 0;
    const timers = [];
    const iv = setInterval(() => {
      while (next < c.currentTime + 0.1) {
        const o = c.createOscillator();
        const g = c.createGain();
        o.frequency.value = n % beats === 0 ? 1600 : 1000;
        g.gain.setValueAtTime(0.5, next);
        g.gain.exponentialRampToValueAtTime(0.001, next + 0.05);
        o.connect(g).connect(c.destination);
        o.start(next);
        o.stop(next + 0.06);
        const b = n % beats;
        timers.push(setTimeout(() => setBeat(b), Math.max(0, (next - c.currentTime) * 1000)));
        next += 60 / bpm;
        n++;
      }
    }, 25);
    return () => { clearInterval(iv); timers.forEach(clearTimeout); setBeat(-1); };
  }, [on, bpm, beats]);

  const nudge = (d) => setBpm((b) => Math.max(30, Math.min(260, b + d)));
  return (
    <div className="space-y-5" data-testid="metronome">
      <div className="flex items-end gap-4">
        <span className="mono text-6xl font-bold text-yellow-400 tabular-nums" data-testid="metronome-bpm">{bpm}</span>
        <span className="mono-label pb-2">BPM</span>
        <div className="ml-auto flex gap-2">
          <button onClick={() => nudge(-1)} data-testid="metronome-minus-btn" className="grid h-9 w-9 place-items-center rounded-[3px] border border-zinc-700 hover:border-yellow-400"><Minus className="h-4 w-4" /></button>
          <button onClick={() => nudge(1)} data-testid="metronome-plus-btn" className="grid h-9 w-9 place-items-center rounded-[3px] border border-zinc-700 hover:border-yellow-400"><Plus className="h-4 w-4" /></button>
        </div>
      </div>
      <input type="range" min={30} max={260} value={bpm} onChange={(e) => setBpm(+e.target.value)} data-testid="metronome-bpm-slider" className="w-full accent-yellow-400" />
      <div className="flex gap-2">
        {Array.from({ length: beats }, (_, i) => (
          <span key={i} className={`h-3 flex-1 rounded-sm transition-colors duration-75 ${beat === i ? (i === 0 ? "bg-pink-500 glow-pink" : "bg-[#39ff6a] glow-green") : "bg-zinc-800"}`} />
        ))}
      </div>
      <div className="flex items-center gap-3">
        <button onClick={() => setOn(!on)} data-testid="metronome-play-btn"
          className={`flex items-center gap-2 rounded-[3px] px-5 py-2.5 font-bold transition-colors ${on ? "bg-pink-500 text-white" : "bg-yellow-400 text-black hover:bg-yellow-300"}`}>
          {on ? <Square className="h-4 w-4" /> : <Play className="h-4 w-4" />} {on ? "Stop" : "Start"}
        </button>
        <select value={beats} onChange={(e) => setBeats(+e.target.value)} data-testid="metronome-beats-select" className="rounded-[3px] bg-black border border-zinc-800 px-3 py-2.5 text-sm">
          {[2, 3, 4, 5, 6, 7].map((b) => <option key={b} value={b}>{b} beats / bar</option>)}
        </select>
      </div>
    </div>
  );
};
